import React from "react";

const geal = () => {
  return (
    <div className="p-5 sm:p-10 font-Montserrat space-y-2 bg-white text-black">
      <p className="font-medium text-base">
        At{" "}
        <a className="text-red font-semibold" href="GARUDAYAAN">
          Garudavega Earth and Artha Laysis Pvt. Ltd.
        </a>
        , one of Bangalore's top logistics companies, we are is a dynamic
        infrastructure and development company specializing in the
        transformation of land into thriving ecosystems. From strategic land
        acquisition to residential townships, from high-impact commercial spaces
        to robust industrial hubs — we develop spaces that matter.
      </p>
      <p className="font-medium text-base">
        With a team of visionary planners, civil engineers, architects, and
        legal experts, we are redefining infrastructure by blending aesthetics,
        compliance, sustainability, and value. Every square foot we build is
        rooted in a purpose — to serve people, power growth, and protect the
        future.
      </p>
      <p className="font-medium text-base">
        Whether it's transforming raw land into plotted developments, creating
        high-performance logistics parks, or designing eco-conscious residential
        enclaves, our mission is clear: create landmark developments that stand
        the test of time.
        <a className="ml-1 text-red font-semibold" href="https://www.garudaproperties.com/">
          www.garudaproperties.com
        </a>
        .
      </p>
    </div>
  );
};

export default geal;
